<template>
    <Button
        @click="isOpen = true"
        iconName="plus"
        color="dark"
    >
        Create
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
        width="wide"
    >
        <template #title> Create </template>
        <template #content>
            <ApiForm
                :url="RoutePathAppEnum.Services"
                method="POST"
                ref="apiFormRef"
            >
                <ServiceForm
                    :serviceAggregate="null"
                    :meetingLocations="meetingLocations"
                    :errors="
                        apiFormRef?.response?.getErrors() ??
                        new ApiFormErrors({})
                    "
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
            >
                Cancel
            </Button>
            <Button
                @click="submit"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ServiceForm from '@/App/Service/Component/Service/ServiceForm.vue'
    import { type MeetingLocationType } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const props = defineProps({
        meetingLocations: {
            type: Array as PropType<MeetingLocationType[]>,
            required: true,
        },
    })

    const isOpen = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.finally(() => {
            isOpen.value = false
        })
    }
</script>
